import * as React from "react";
import { forwardRef } from "react";
const PersonSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M5.102 4.563a2.96 2.96 0 1 1 5.797 0l-.27 1.299a2.685 2.685 0 0 1-5.257 0z", clipRule: "evenodd" }),
    React.createElement("path", { d: "M14 15H2c-.552 0-1.01-.452-.908-.995C1.666 10.965 4.833 9 8 9s6.334 1.965 6.908 5.006c.102.542-.356.994-.908.994" }));
const ForwardRef = forwardRef(PersonSVG);
export default ForwardRef;
//# sourceMappingURL=Person.js.map